export default "__VITE_ASSET__vf7z55U0__"